import React, { useRef, useState } from 'react'
import { ContractForm } from '@/entity/contracts'
import { ModalTemplate } from '@/ui'
import styles from './style.module.scss'
import { LoadingBlocker } from '@/components/Loader'
import { Documents } from '@/entity/contracts/ui/form/Documents/Documents'
import { EmploymentContractFile } from '@/entity/contracts/ui/form/employmentСontractFile/employmentСontractFile'

export const Form = ({
	initialValues,
	options = {},
	onSubmit,
	onGetHandBookOptions,
	onCancel,
	setIsEsutd,
	isEsutd,
	isElectronic,
	CloseAndUpdateFilter,
	fetchData,
	filters,
	page,
	pageSize,
}) => {
	const formRef = useRef(null)
	const [isAttachProjectFile, setAttachProjectFile] = useState(false)
	const [attachProjectFileData, setAttachProjectFileData] = useState({})
	const [isPdfView, setPdfView] = useState(false)
	const [document, setDoc] = useState([])
	let isDictionaryLoaded = options?.positionsByKnz?.length > 0 && options?.positions?.length > 0

	const attachProjectFile = (values) => {
		setAttachProjectFileData(values)
		setAttachProjectFile(true)
	}

	const attachFileData = (values) => {
		setAttachProjectFileData(values)
		setPdfView(true)
	}

	return (
		<>
			<ModalTemplate onClose={onCancel}>
				<div className={`scroll ${styles.wrapper}`}>
					{isDictionaryLoaded ? (
						<ContractForm
							options={options}
							initialValues={initialValues}
							advanced
							onSubmit={onSubmit}
							onGetHandBookOptions={onGetHandBookOptions}
							onCancel={onCancel}
							formRef={formRef}
							isTitle
							setIsEsutd={setIsEsutd}
							isEsutd={isEsutd}
							isElectronicButton={isElectronic}
							fetchData={fetchData}
							attachProjectFile={attachProjectFile}
							CloseAndUpdateFilter={CloseAndUpdateFilter}
						/>
					) : null}
				</div>
			</ModalTemplate>
			{isAttachProjectFile && (
				<Documents
					onClose={() => setAttachProjectFile(false)}
					document={document}
					setDoc={setDoc}
					nextPage={attachFileData}
					attachProjectFileData={attachProjectFileData}
				/>
			)}
			{isPdfView && (
				<EmploymentContractFile
					onClose={() => setPdfView(false)}
					documentData={document}
					attachProjectFileData={attachProjectFileData}
					CloseAndUpdateFilter={CloseAndUpdateFilter}
					filters={filters}
					page={page}
					pageSize={pageSize}
					saveUrl={'/contract/econtract/save'}
				/>
			)}
			{!isDictionaryLoaded && <LoadingBlocker />}
		</>
	)
}
